import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcDone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.955 8.748a.75.75 0 0 0-1.06-1.06l-9.017 9.015-4.773-4.773a.75.75 0 0 0-1.06 1.06l5.126 5.127q.075.073.157.128a1 1 0 0 0 1.258-.128z"
  }));
}
var IcDone = createNolIcon(/*#__PURE__*/forwardRef(SvgIcDone));

export { IcDone as I };
